/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Caption_Track_LabelInputs */

const en_embed_captions_caption_track_label = /** @type {(inputs: Embed_Captions_Caption_Track_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption Track`)
};

const fr_embed_captions_caption_track_label = /** @type {(inputs: Embed_Captions_Caption_Track_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piste de sous-titres`)
};

const de_embed_captions_caption_track_label = /** @type {(inputs: Embed_Captions_Caption_Track_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelspur`)
};

const it_embed_captions_caption_track_label = /** @type {(inputs: Embed_Captions_Caption_Track_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traccia didascalia`)
};

const ru_embed_captions_caption_track_label = /** @type {(inputs: Embed_Captions_Caption_Track_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры`)
};

const es_embed_captions_caption_track_label = /** @type {(inputs: Embed_Captions_Caption_Track_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pista de subtítulos`)
};

const zh_cn2_embed_captions_caption_track_label = /** @type {(inputs: Embed_Captions_Caption_Track_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕轨道`)
};

const ja_embed_captions_caption_track_label = /** @type {(inputs: Embed_Captions_Caption_Track_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプショントラック`)
};

const hi_embed_captions_caption_track_label = /** @type {(inputs: Embed_Captions_Caption_Track_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन ट्रैक`)
};

const pt_pt2_embed_captions_caption_track_label = /** @type {(inputs: Embed_Captions_Caption_Track_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legenda da faixa`)
};

/**
* | output |
* | --- |
* | "Caption Track" |
*
* @param {Embed_Captions_Caption_Track_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_caption_track_label = /** @type {((inputs?: Embed_Captions_Caption_Track_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Caption_Track_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_caption_track_label(inputs)
	if (locale === "de") return de_embed_captions_caption_track_label(inputs)
	if (locale === "it") return it_embed_captions_caption_track_label(inputs)
	if (locale === "ru") return ru_embed_captions_caption_track_label(inputs)
	if (locale === "es") return es_embed_captions_caption_track_label(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_caption_track_label(inputs)
	if (locale === "ja") return ja_embed_captions_caption_track_label(inputs)
	if (locale === "hi") return hi_embed_captions_caption_track_label(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_caption_track_label(inputs)
	return en_embed_captions_caption_track_label(inputs)
});